export default __webpack_public_path__ + "static/media/12.2bc797f0.png";